<template>
<div v-if="statement" id="statement-history">
	<div class="row mt-20 mb-20">
    <div class="panel panel-default border-panel card-view">
      <div class="panel-wrapper collapse in">
        <div class="panel-body">
          <div class="row">
            <div class="col-md-12 statement-info">
              <div class="col-md-3">
                <span class="title">{{$t('app.statements.identifier')}}</span>
                <span>{{statement.identifier}}</span>
              </div>
              <div class="col-md-3">
                <span class="title">{{$t('app.statements.criteria_category_name')}}</span>
                <span>{{statement.criteria_category_name}}</span>
              </div>
              <div class="col-md-3">
                <span class="title">{{$t('app.statements.verification_question_name')}}</span>
                <span>{{statement.verification_question_name}}</span>
              </div>
              <div class="col-md-3">
                <span class="title">{{$t('app.statements.statement')}}</span>
                <span>{{statement.statement}}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="panel panel-default border-panel card-view">
      <div class="panel-wrapper collapse in">
        <report-list
          v-for="(inspection,index) in statement.inspections"
          :key="index"
          :readOnly="true"
          :data="inspection.inspections_statements"
          @updateResult="updateResultClicked"
          @updateTask="updateTaskClicked"
          @updateMemoClicked="updateMemoClicked"
        />
      </div>
    </div>
  </div>
</div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import InspectionReportList from '@/components/shared/lists/InspectionReportList';

export default {
  name: 'StatementHistory',
  components: {
    'report-list': InspectionReportList,
  },
  props: {
    statementId: {
      type: Number,
      required: true,
    },
  },
  data() {
    return {
      statement: {},
    };
  },
  created() {
    this.fetchStatementWithInspection(this.statementId).then((response) => {
      this.statement = response;
    });
  },
  computed: {
    ...mapGetters({
    }),
  },
  methods: {
    ...mapActions({
      fetchStatementWithInspection: 'statements/fetchStatementWithInspection',
    }),
  },
  watch: {
  },
};
</script>

<style lang="scss">
#statement-history {
  .card-view {
    margin-left: 0 !important;
    margin-right: 0 !important;
  }
  .statement-info > span {
    float: left;
    clear: left;
  }
  .title{
    font-weight: bold;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modules/inspections/StatementHistoryScreen.vue